// console.log("loading scroll script");
if ("scrollRestoration" in history) {
  history.scrollRestoration = "manual";
}

const preventScrollRestoration =
  sessionStorage.getItem("preventScrollRestoration") === "true" ? true : false;
// console.log('checking for preventScrollRestoration: ', preventScrollRestoration)
window.addEventListener("pagehide", function () {
  // Save the scroll position
  // console.log('Saving scroll position');
  const scrollPosition =
    window.scrollY ||
    document.documentElement.scrollTop ||
    document.body.scrollTop;
  console.log("saving scrollPosition:", scrollPosition);
  sessionStorage.setItem("scrollPosition", scrollPosition.toString());
});

// Load the scroll position, if it exists
if (!preventScrollRestoration) {
  // Using setTimeout to ensure this runs after other document load events
  // console.log('getting scroll position');
  const scrollPosition = sessionStorage.getItem("scrollPosition");
  if (scrollPosition) {
    setTimeout(function () {
      window.scrollTo(
        0,
        parseInt(sessionStorage.getItem("scrollPosition") || "0")
      );
    }, 0);
  }
}

sessionStorage.setItem("preventScrollRestoration", "false");
